import React, { Fragment } from 'react';
import './button.scss';

const EdenredButton = ({
	btnType,
	//style= 'primary',
	type = 'submit',
	children,
	onPress,
	onClick,
	disabled = false,
	loading,
	icon = null,
	formType,
	style = {},
	noShadow = false,
	className = '',
}) => {
	const renderButton = () => (
		<button
			type={formType}
			onClick={onClick}
			className={`${className} edenRedButton ${type} ${loading ? 'loading disablebutton' : ''} ${noShadow ? 'noShadow' : ''}`}
			disabled={disabled}
			loading={loading}
			style={style}>
			{!loading ? (
				<>
					{icon ? <div style={{ marginRight: 5 }}> {icon} </div> : null}
					{children}
				</>
			) : (
				<span className="loader" />
			)}
		</button>
	);

	return <Fragment>{renderButton()}</Fragment>;
};

export default EdenredButton;
